import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth/core/auth.service';

/**
 * Represents a dummy authentification service.
 * A real implementation should be provided using dependency injection
 * e.g. `{ provide: AuthService, useClass: MyAuthService }`.
 */
@Injectable({
  providedIn: 'root',
})
export class ProjectionAuthService extends AuthService {
  authenticateReq(req: HttpRequest<any>): Promise<HttpRequest<any>> {
    return Promise.resolve(req);
  }
}
